import { render } from "./Bets.vue?vue&type=template&id=5f0cc0d0"
import script from "./Bets.vue?vue&type=script&lang=js"
export * from "./Bets.vue?vue&type=script&lang=js"

import "./Bets.vue?vue&type=style&index=0&id=5f0cc0d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__